/** @jsxRuntime classic */
/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/react';
import { AnswerDto, AnswerTemplateCustomerDto, QuestionDto } from '@bondsports/types';
import { RCOrganization } from '../../../types/entities/coreEntites/Organization';
import { TemplateHeader } from './TemplateHeader';
import { CustomerDetails } from './CustomerDetails';
import { TemplateForm } from './TemplateForm';
import { containerCss } from '../styles';

export interface ApplicationTemplateProps {
	organization: RCOrganization;
	customer: AnswerTemplateCustomerDto;
	answers: AnswerDto[];
	questions: QuestionDto[];
	dateSigned: string | Date;
	timezone?: string;
}

export const ApplicationTemplate: FC<ApplicationTemplateProps> = props => {
	const { organization, customer, questions, answers, dateSigned, timezone } = props;

	return (
		<div css={containerCss} data-aid="ApplicationTemplate">
			<TemplateHeader organization={organization} address={organization?.address} />
			<CustomerDetails customer={customer} dateSigned={dateSigned} timezone={timezone || Intl.DateTimeFormat().resolvedOptions().timeZone} />
			<TemplateForm answers={answers} questions={questions} />
		</div>
	);
};
